import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { AddToDrive as AddToDriveIcon } from '@mui/icons-material';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { GOOGLE_CONFIG } from '../../../config';
import { GOOGLE_DRIVE_FILE_SCOPE } from '../../services/api/google-drive.api';

const GoogleDriveAuthorizationButton = ({
  children,
  disabled,
  onAuthorizationError,
  onAuthorizationStart,
  onAuthorized
}) => {
  const requestDriveAccess = useGoogleLogin({
    scope: GOOGLE_DRIVE_FILE_SCOPE,
    overrideScope: true,
    include_granted_scopes: true,
    onSuccess: (response) => {
      if (!response?.access_token) {
        onAuthorizationError();
        return;
      }
      onAuthorized(response.access_token);
    },
    onError: onAuthorizationError,
    onNonOAuthError: onAuthorizationError
  });

  return (
    <Button
      startIcon={<AddToDriveIcon />}
      onClick={() => {
        onAuthorizationStart();
        requestDriveAccess();
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

GoogleDriveAuthorizationButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAuthorizationError: PropTypes.func.isRequired,
  onAuthorizationStart: PropTypes.func.isRequired,
  onAuthorized: PropTypes.func.isRequired
};

const GoogleDriveTemplateButton = (props) => {
  if (!GOOGLE_CONFIG.GOOGLE_CLIENT_ID) {
    return (
      <Button startIcon={<AddToDriveIcon />} disabled>
        {props.children}
      </Button>
    );
  }

  return (
    <GoogleOAuthProvider
      clientId={GOOGLE_CONFIG.GOOGLE_CLIENT_ID}
      onScriptLoadError={props.onAuthorizationError}
    >
      <GoogleDriveAuthorizationButton {...props} />
    </GoogleOAuthProvider>
  );
};

GoogleDriveTemplateButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAuthorizationError: PropTypes.func.isRequired,
  onAuthorizationStart: PropTypes.func.isRequired,
  onAuthorized: PropTypes.func.isRequired
};

export default GoogleDriveTemplateButton;
